import type { RouteRecordRaw } from 'vue-router';

export const prescriptionsRoutes: RouteRecordRaw[] = [
  {
    path: 'prescriptions',
    name: 'prescriptions',
    component: () => import('./pages/PrescriptionsListPage.vue'),
    meta: { title: 'Prescriptions', requiresAuth: true, permission: 'view_prescriptions' },
  },
  {
    path: 'prescriptions/new',
    name: 'prescriptions.create',
    component: () => import('./pages/PrescriptionEditorPage.vue'),
    meta: { title: 'New prescription', requiresAuth: true, permission: 'create_prescriptions' },
  },
  {
    path: 'prescriptions/:id',
    name: 'prescriptions.show',
    component: () => import('./pages/PrescriptionEditorPage.vue'),
    meta: { title: 'Prescription', requiresAuth: true, permission: 'view_prescriptions' },
  },
];
